import type { Step as StepV3 } from '@wix/ambassador-online-programs-v3-step/types';

export const getVideoOptions = (step: any) => {
  return (step as StepV3)?.videoOptions;
};
export const isVideoStep = (step: any) => {
  return !!getVideoOptions(step);
};
